var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 28H24.6663C23.9299 28 23.333 27.4031 23.333 26.6667V13.3333C23.333 12.597 23.9299 12 24.6663 12H25.9997C26.7361 12 27.333 12.597 27.333 13.3333V26.6667C27.333 27.4031 26.7361 28 25.9997 28Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H26V8",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 4.66666C25.3333 4.66666 20 11.3333 6 16",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 28H15.3333C14.5969 28 14 27.4031 14 26.6667V18C14 17.2636 14.5969 16.6667 15.3333 16.6667H16.6667C17.4031 16.6667 18 17.2636 18 18V26.6667C18 27.4031 17.4031 28 16.6667 28Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 28H6.00033C5.26395 28 4.66699 27.4031 4.66699 26.6667V21.3333C4.66699 20.5969 5.26395 20 6.00033 20H7.33366C8.07003 20 8.66699 20.5969 8.66699 21.3333V26.6667C8.66699 27.4031 8.07003 28 7.33366 28Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/p1.4fae09721cebd3826f9dea848fe7b5af.svg";
export { ForwardRef as ReactComponent };